// @flow
const tenantsFileDropStyles = {
  container: (theme: Object) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    minHeight: 400,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1)
    }
  })
};

export default tenantsFileDropStyles;
